import {defineStore} from "pinia";
import {useLocalStorage} from "@vueuse/core";
import { useUserStore } from '@/components/stores/user.js';

export const useAdminStore = defineStore("admin", {
    state: () => ({

        redirect: null,
        admin: useLocalStorage('admin', {
            data: {
                name: null
            }
        }),
        error: {
            message: ''
        },

    }),

    actions: {
        setRedirect(path) {
            this.redirect = path;
            localStorage.setItem('adminRedirect', path);
        },
        clearRedirect() {
            this.redirect = null;
            localStorage.removeItem('adminRedirect');
        },
        async fetchAdmin(router) {

            try {
                const res = await axios.get("/api/admin");
                const adminData = await res.data;
                this.admin = adminData || { data: { name: null } };
            } catch (error) {
                // Set the redirect path to the current fullPath
                this.setRedirect(router.currentRoute.value.fullPath);
                router.push({name: 'admin-login'})
            }

        },

        login(router, email, password, remember) {
            // Load redirect from local storage to ensure it is set correctly
            this.redirect = localStorage.getItem('adminRedirect');
            // Access the user store to remove old user data. Useful for staff who log into both and are left with user info causing front-end issues ie language drop down appearing when in admin pages..
            const userStore = useUserStore()
            axios.get('/sanctum/csrf-cookie').then(() => {

                const loginFieldsArray = {
                    'email': email,
                    'password': password,
                    'remember': remember
                }

                this.error.message = '';

                axios
                    .post('/api/admin-login', loginFieldsArray)
                    .then(res => {
                        userStore.resetUser()
                        this.admin = res.data;
                        this.error.message = '';

                        this.checkRestrictions(res.data.roles)
                        if (this.redirect) {
                            router.push(this.redirect)
                        } else {
                            router.push({name: 'client-files'})
                        }
                        // Clear the redirect after successful login
                        this.clearRedirect();
                    })
                    .catch(() => {
                        this.error.message = 'Incorrect login details.';
                    })

            })
        },

        checkRestrictions(roles){
            if(roles.includes("super-admin")){
                localStorage.setItem('consultantRestriction', 'false');
                localStorage.setItem('tlRestriction', 'false');
            }
        },

        logout() {

            axios.get('/sanctum/csrf-cookie').then(() => {
                axios
                    .post('/api/admin-logout')
                    .then(() => {
                        this.redirect = null;
                        this.admin.data.name = null
                        this.router.push({
                            name: 'admin-login'
                        })
                    })
                    .catch(() => {

                    })
            })

        }
    }
})
